export class GeocodingResponseDto {
    public address!: string;
    public latitude!: number;
    public longitude!: number;
}